import { hasFeature } from '@marketplace/helpers/url.js'

export const getters = {
    isODF() {
        return hasFeature('odf_test') || window.Store.isOdfActive || false
    },

    isConnectAndGrow() {
        return (
            hasFeature('connect_and_grow_test') ||
            window.Store.isConnectAndGrowActive ||
            false
        )
    },

    isDiscoveryDays() {
        return window.Store.isDiscoveryDays
    },

    isLowMinimumDays() {
        return window.Store.isLowMinimums
    },

    isWarehouseSale() {
        return window.Store.isWarehouseSale
    },
}
